var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tax-type-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "", enctype: "multipart/form-data" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitUserGuideData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$t("user_guides.name")) + " "),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-7" },
              [
                _c("base-input", {
                  ref: "name",
                  attrs: { type: "text" },
                  on: {
                    input: function ($event) {
                      return _vm.$v.userGuideData.name.$touch()
                    },
                  },
                  model: {
                    value: _vm.userGuideData.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.userGuideData, "name", $$v)
                    },
                    expression: "userGuideData.name",
                  },
                }),
                _vm._v(" "),
                _vm.$v.userGuideData.name.$error
                  ? _c("div", [
                      !_vm.$v.userGuideData.name.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                _vm._s(_vm.$tc("validation.name_required"))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.userGuideData.name.minLength
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$tc(
                                      "validation.name_min_length",
                                      _vm.$v.userGuideData.name.$params
                                        .minLength.min,
                                      {
                                        count:
                                          _vm.$v.userGuideData.name.$params
                                            .minLength.min,
                                      }
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$t("user_guides.type")) + " "),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-7" },
              [
                _c("base-select", {
                  ref: "type",
                  attrs: {
                    options: _vm.TypeOptions,
                    "allow-empty": false,
                    "show-labels": false,
                    tabindex: 5,
                    placeholder: _vm.$t("user_guides.select_type"),
                    label: "name",
                    "track-by": "name",
                  },
                  model: {
                    value: _vm.userGuideData.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.userGuideData, "type", $$v)
                    },
                    expression: "userGuideData.type",
                  },
                }),
                _vm._v(" "),
                _vm.$v.userGuideData.type.$error
                  ? _c("div", [
                      !_vm.$v.userGuideData.type.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$t("user_guides.status")) + " "),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-7" },
              [
                _c("base-select", {
                  attrs: {
                    options: _vm.statusOptions,
                    "allow-empty": false,
                    "show-labels": false,
                    tabindex: 5,
                    placeholder: _vm.$t("user_guides.select_status"),
                    label: "name",
                    "track-by": "name",
                  },
                  model: {
                    value: _vm.userGuideData.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.userGuideData, "status", $$v)
                    },
                    expression: "userGuideData.status",
                  },
                }),
                _vm._v(" "),
                _vm.$v.userGuideData.status.$error
                  ? _c("div", [
                      !_vm.$v.userGuideData.status.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$t("user_guides.document")) + " "),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-7" }, [
              _vm.isEdit == false
                ? _c("input", {
                    ref: "file",
                    attrs: { type: "file" },
                    on: {
                      change: _vm.onFileChange,
                      input: function ($event) {
                        return _vm.$v.userGuideData.document.$touch()
                      },
                    },
                  })
                : _c("input", {
                    ref: "file",
                    attrs: { type: "file" },
                    on: { change: _vm.onFileChange },
                  }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "form-group__message text-danger" }, [
                _vm._v(_vm._s(_vm.$t("user_guides.documentSizelessthan20MB"))),
              ]),
              _vm._v(" "),
              _vm.isEdit == false && _vm.$v.userGuideData.document.$error
                ? _c("div", [
                    !_vm.$v.userGuideData.document.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeUserGuideModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  loading: _vm.isLoading,
                  disabled: _vm.isSubmitDisabled,
                  color: "theme",
                  icon: "save",
                  type: "submit",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      !_vm.isEdit
                        ? _vm.$t("general.save")
                        : _vm.$t("general.update")
                    ) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }